// extracted by mini-css-extract-plugin
export default {"container":"CounterItem_container__GG0jF","counter":"CounterItem_counter__BRK60","count":"CounterItem_count__5vkJ5"};